import { BrowserRouter, Routes, Route } from "react-router-dom";
import GoogleCallback           from "./pages/GoogleCallback";
import CreatePassword           from "./pages/CreatePassword";
import Login                    from "./pages/Login";
import Register                 from "./pages/Register";
import AdminLogin               from "./pages/AdminLogin";
import SuperadminLogin          from "./pages/SuperadminLogin";
import LandingPage              from "./pages/LandingPage";
import Dashboard                from "./pages/Admin/Dashboard";
import ItemsIndex               from "./pages/Admin/items/index";
import ItemCreate               from "./pages/Admin/items/Create";
import ItemDetail               from "./pages/Admin/items/Detail";
import MoveItem                 from "./pages/Admin/items/MoveItem";
import ArchivedItems            from "./pages/Admin/items/ArchivedItems";
import RoomsIndex               from "./pages/Admin/rooms/index";
import CreateProcurement        from "./pages/Admin/procurement/CreateProcurement";
import ListProcurement          from "./pages/Admin/procurement/ListProcurement";
import DetailProcurement        from "./pages/Admin/procurement/DetailProcurement";
import RoomDetail               from "./pages/Admin/rooms/RoomDetail";
import UserManagement           from "./pages/Admin/users/index";
import LaporanPengadaan         from "./pages/Admin/laporan/LaporanPengadaan";
import LogAktivitas             from "./pages/Admin/activitylogs/LogAktivitas";
import ListAtk                  from "./pages/Admin/atk/ListAtk";
import CreateAtk                from "./pages/Admin/atk/CreateAtk";
import DetailAtk                from "./pages/Admin/atk/DetailAtk";
import AtkItems                 from "./pages/Admin/atk/AtkItems";
import CreateAtkItem            from "./pages/Admin/atk/CreateAtkItem";
import UserDashboard            from "./pages/User/UserDashboard";
import UserListProcurement      from "./pages/User/UserListProcurement";
import UserDetailProcurement    from "./pages/User/UserDetailProcurement";
import UserListAtk              from "./pages/User/UserListAtk";
import UserDetailAtk            from "./pages/User/UserDetailAtk";
import ProfilePage              from "./pages/User/ProfilePage";
import ProtectedRoute           from "./components/ProtectedRoute";
import SuperadminLayout         from "./layouts/SuperadminLayout";
import AdminLayout              from "./layouts/AdminLayout";
import UserLayout               from "./layouts/UserLayout";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── PUBLIC ── */}
        <Route path="/"                     element={<LandingPage />} />
        <Route path="/login"                element={<Login />} />
        <Route path="/register"             element={<Register />} />
        <Route path="/admin/login"          element={<AdminLogin />} />
        <Route path="/superadmin/login"     element={<SuperadminLogin />} />  {/* ← NEW */}
        <Route path="/auth/google/callback" element={<GoogleCallback />} />
        <Route path="/create-password"      element={<CreatePassword />} />

        {/* ── SUPERADMIN (/superadmin) — semua fitur ── */}
        <Route
          path="/superadmin"
          element={
            <ProtectedRoute allowedRoles={["superadmin"]}>
              <SuperadminLayout />
            </ProtectedRoute>
          }
        >
          <Route index                         element={<Dashboard />} />
          <Route path="users"                  element={<UserManagement />} />
          <Route path="items"                  element={<ItemsIndex />} />
          <Route path="items/archived"         element={<ArchivedItems />} />
          <Route path="items/create"           element={<ItemCreate />} />
          <Route path="items/:id"              element={<ItemDetail />} />
          <Route path="items/:id/edit"         element={<ItemCreate />} />
          <Route path="items/:id/move"         element={<MoveItem />} />
          <Route path="rooms"                  element={<RoomsIndex />} />
          <Route path="rooms/:id"              element={<RoomDetail />} />
          <Route path="procurement"            element={<ListProcurement />} />
          <Route path="procurement/create"     element={<CreateProcurement />} />
          <Route path="procurement/:id"        element={<DetailProcurement />} />
          <Route path="atk"                    element={<ListAtk />} />
          <Route path="atk/create"             element={<CreateAtk />} />
          <Route path="atk/:id"                element={<DetailAtk />} />
          <Route path="atk/items"              element={<AtkItems />} />
          <Route path="atk/items/create"       element={<CreateAtkItem />} />
          <Route path="atk/items/:id/edit"     element={<CreateAtkItem />} />
          <Route path="atk/items/:id"          element={<AtkItems />} />
          <Route path="laporan"                element={<LaporanPengadaan />} />
          <Route path="log-aktivitas"          element={<LogAktivitas />} />
        </Route>

        {/* ── ADMIN (/admin) — tanpa Kelola User & Log Aktivitas ── */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index                         element={<Dashboard />} />
          <Route path="items"                  element={<ItemsIndex />} />
          <Route path="items/archived"         element={<ArchivedItems />} />
          <Route path="items/create"           element={<ItemCreate />} />
          <Route path="items/:id"              element={<ItemDetail />} />
          <Route path="items/:id/edit"         element={<ItemCreate />} />
          <Route path="items/:id/move"         element={<MoveItem />} />
          <Route path="rooms"                  element={<RoomsIndex />} />
          <Route path="rooms/:id"              element={<RoomDetail />} />
          <Route path="procurement"            element={<ListProcurement />} />
          <Route path="procurement/create"     element={<CreateProcurement />} />
          <Route path="procurement/:id"        element={<DetailProcurement />} />
          <Route path="atk"                    element={<ListAtk />} />
          <Route path="atk/create"             element={<CreateAtk />} />
          <Route path="atk/:id"                element={<DetailAtk />} />
          <Route path="atk/items"              element={<AtkItems />} />
          <Route path="atk/items/create"       element={<CreateAtkItem />} />
          <Route path="atk/items/:id/edit"     element={<CreateAtkItem />} />
          <Route path="atk/items/:id"          element={<AtkItems />} />
          <Route path="laporan"                element={<LaporanPengadaan />} />
          {/* ❌ Tidak ada route users & log-aktivitas untuk admin */}
        </Route>

        {/* ── USER (/user) ── */}
        <Route
          path="/user"
          element={
            <ProtectedRoute allowedRoles={["user"]}>
              <UserLayout />
            </ProtectedRoute>
          }
        >
          <Route index                         element={<UserDashboard />} />
          <Route path="dashboard"              element={<UserDashboard />} />
          <Route path="procurement"            element={<UserListProcurement />} />
          <Route path="procurement/create"     element={<CreateProcurement />} />
          <Route path="procurement/:id"        element={<UserDetailProcurement />} />
          <Route path="atk"                    element={<UserListAtk />} />
          <Route path="atk/create"             element={<CreateAtk />} />
          <Route path="atk/:id"                element={<UserDetailAtk />} />
          <Route path="profile"                element={<ProfilePage />} />
        </Route>

        {/* ── 404 ── */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;